import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';

const timeline = [
  {
    year: '2010年',
    title: '大手企業 広報部門に入社',
    desc: '新卒で大手企業の広報部門に配属。プレスリリース作成・メディア対応を担当。',
  },
  {
    year: '2013年',
    title: 'インタビュー担当として本格始動',
    desc: '社内外の著名人・専門家へのインタビューを担当。医師・研究者・経営者など多様な職種の方々と対話を重ねる。',
  },
  {
    year: '2018年',
    title: 'インタビュー累計200件突破',
    desc: '「聞く力」と「言語化する力」を武器に、広報のスペシャリストとして社内表彰を受ける。',
  },
  {
    year: '2020年',
    title: '内科医のパートナーと出会う',
    desc: 'マッチングアプリを通じて内科医のパートナーと出会い、交際開始。医師という職業の人間の思考・会話パターンを日常的に観察するようになる。',
  },
  {
    year: '2022年',
    title: 'Dr.Catch 開設',
    desc: '「医師との会話がうまくいかない」という声を多く聞き、自身の経験を活かしたカウンセリングサービスを開始。',
  },
  {
    year: '2024年',
    title: '書籍出版',
    desc: '医師・高収入男性とのマッチングアプリでのやりとりについて、実際の経験をもとにした書籍を出版。',
  },
];

const strengths = [
  {
    icon: 'ri-mic-line',
    title: 'インタビュー200件以上',
    desc: '大手企業広報として医師・研究者・経営者など多様な専門家へのインタビューを重ねてきました。「聞く力」と「言語化する力」はここで培われました。',
  },
  {
    icon: 'ri-stethoscope-line',
    title: '医師との日常生活',
    desc: '内科医のパートナーと東京で暮らしています。医師がどう話し、どう黙り、何を大切にするかを、日常の中で観察し続けています。',
  },
  {
    icon: 'ri-heart-line',
    title: '恋愛・婚活の実体験',
    desc: 'マッチングアプリで医師と出会い、関係を築いた実体験があります。戦略ではなく、実際に機能した会話の積み重ねをお伝えします。',
  },
  {
    icon: 'ri-book-open-line',
    title: '書籍出版',
    desc: '医師・高収入男性とのマッチングアプリでのやりとりについて書いた書籍を出版。実体験に基づいた内容が多くの方に支持されています。',
  },
  {
    icon: 'ri-chat-smile-3-line',
    title: '傾聴と共感',
    desc: '広報時代に培った傾聴スキルで、あなたの状況を丁寧に聞き取ります。アドバイスの前に、まずあなたのことを理解することを大切にしています。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '煽らない・急かさない',
    desc: '「今すぐ変わらなければ」という焦りを煽るのではなく、あなたのペースで準備できる場所を提供します。信頼関係を大切にしています。',
  },
];

const mediaItems = [
  { label: 'セッション実施数', value: '150+', unit: '件' },
  { label: 'リピート率', value: '78', unit: '%' },
  { label: 'インタビュー経験', value: '200+', unit: '件' },
  { label: 'サービス開始', value: '2022', unit: '年' },
];

export default function Profile() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#FFF8F5] to-white">
      <Navigation />

      <main className="pt-32 pb-20">
        {/* ── Hero Profile ── */}
        <section className="relative overflow-hidden mb-20">
          <div className="absolute inset-0 pointer-events-none select-none">
            <i className="ri-flower-line absolute top-10 left-[8%] text-[120px] text-[#E8D5D5]/30"></i>
            <i className="ri-leaf-line absolute bottom-10 right-[6%] text-[100px] text-[#D4A5A5]/20"></i>
          </div>

          <div className="max-w-5xl mx-auto px-6">
            <div className="text-center mb-12">
              <p className="text-sm tracking-[0.3em] text-[#C9A0A0] uppercase mb-3">About</p>
              <h1 className="text-4xl font-serif mb-4 text-[#2C2C2C]">プロフィール</h1>
              <div className="w-24 h-px bg-[#D4A5A5] mx-auto"></div>
            </div>

            {/* Main Profile Card */}
            <div className="bg-white rounded-3xl shadow-xl overflow-hidden">
              <div className="grid md:grid-cols-2">
                {/* Photo side */}
                <div className="relative">
                  <img
                    src="https://static.readdy.ai/image/d4208e7c1b6fcc1a247dec5c1658bdd1/c902a90259f3aac8096473bc195c4b03.png"
                    alt="ジェイゾロフト瞳"
                    className="w-full h-full object-cover object-top min-h-[420px]"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
                  <div className="absolute bottom-6 left-6 right-6">
                    <div className="flex gap-2 flex-wrap">
                      <span className="px-3 py-1 bg-white/80 backdrop-blur-sm text-[#C9A0A0] rounded-full text-xs font-medium">
                        元大手企業広報
                      </span>
                      <span className="px-3 py-1 bg-white/80 backdrop-blur-sm text-[#C9A0A0] rounded-full text-xs font-medium">
                        東京在住
                      </span>
                    </div>
                  </div>
                </div>

                {/* Text side */}
                <div className="p-10 flex flex-col justify-center">
                  <h2 className="text-3xl font-serif font-bold mb-1 text-[#2C2C2C]">
                    ジェイゾロフト瞳
                  </h2>
                  <p className="text-[#C9A0A0] text-sm tracking-widest mb-8">Hitomi Zoloft J.</p>

                  <div className="space-y-5 text-[#4A4A4A] leading-loose text-base">
                    <p>
                      元大手企業広報。インタビューを200件以上担当しました。<br />
                      人の話を聞いて、言葉にするのが仕事でした。
                    </p>
                    <p>
                      現在は東京在住。内科医のパートナーと暮らしています。
                    </p>
                    <p>
                      医師との会話がうまくいかない、という話を何度も聞いてきました。<br />
                      医師は話すのが得意ではない人が多い。<br />
                      それは性格の問題ではなく、職業的な特性に近いものだと思っています。
                    </p>
                    <p className="font-serif text-lg text-[#2C2C2C] italic">
                      医師免許はありません。<br />
                      ただ、隣にいます。
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ── Numbers ── */}
        <section className="bg-[#FDF5F2] py-16 mb-20">
          <div className="max-w-5xl mx-auto px-6">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              {mediaItems.map((item) => (
                <div key={item.label} className="text-center">
                  <div className="text-4xl font-serif font-bold text-[#C9A0A0] mb-1">
                    {item.value}
                    <span className="text-xl ml-1">{item.unit}</span>
                  </div>
                  <p className="text-sm text-[#888888]">{item.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ── Strengths ── */}
        <section className="max-w-5xl mx-auto px-6 mb-20">
          <div className="text-center mb-12">
            <p className="text-sm tracking-[0.3em] text-[#C9A0A0] uppercase mb-2">Strengths</p>
            <h2 className="text-2xl font-serif text-[#2C2C2C]">私がお伝えできること</h2>
          </div>
          <div className="grid md:grid-cols-3 gap-6">
            {strengths.map((s) => (
              <div
                key={s.title}
                className="bg-white rounded-2xl p-7 shadow-md hover:shadow-lg transition-shadow duration-300 border border-[#F5E8E4]"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-[#FFF8F5] rounded-full mb-4">
                  <i className={`${s.icon} text-2xl text-[#C9A0A0]`}></i>
                </div>
                <h3 className="text-base font-semibold mb-3 text-[#2C2C2C]">{s.title}</h3>
                <p className="text-sm text-[#666666] leading-relaxed">{s.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* ── Timeline ── */}
        <section className="max-w-5xl mx-auto px-6 mb-20">
          <div className="text-center mb-12">
            <p className="text-sm tracking-[0.3em] text-[#C9A0A0] uppercase mb-2">Timeline</p>
            <h2 className="text-2xl font-serif text-[#2C2C2C]">経歴・あゆみ</h2>
          </div>
          <div className="relative">
            {/* vertical line */}
            <div className="absolute left-[120px] top-0 bottom-0 w-px bg-[#E8D5D5] hidden md:block"></div>
            <div className="space-y-8">
              {timeline.map((item, i) => (
                <div key={i} className="flex flex-col md:flex-row gap-4 md:gap-0">
                  <div className="md:w-[120px] flex-shrink-0 flex md:justify-end md:pr-8 items-start pt-1">
                    <span className="text-sm font-medium text-[#C9A0A0] whitespace-nowrap">{item.year}</span>
                  </div>
                  {/* dot */}
                  <div className="hidden md:flex items-start justify-center w-8 flex-shrink-0 pt-1">
                    <div className="w-3 h-3 rounded-full bg-[#D4A5A5] border-2 border-white shadow-sm mt-0.5"></div>
                  </div>
                  <div className="flex-1 md:pl-6 bg-white rounded-2xl p-6 shadow-sm border border-[#F5E8E4]">
                    <h3 className="text-base font-semibold text-[#2C2C2C] mb-2">{item.title}</h3>
                    <p className="text-sm text-[#666666] leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ── Quote ── */}
        <section className="max-w-5xl mx-auto px-6">
          <div className="bg-gradient-to-br from-[#F5E8E4] to-[#E8D5D5] rounded-3xl p-14 text-center relative overflow-hidden">
            <i className="ri-flower-line absolute -top-4 -right-4 text-[140px] text-white/40 pointer-events-none"></i>
            <i className="ri-leaf-line absolute -bottom-4 -left-4 text-[100px] text-white/30 pointer-events-none"></i>
            <div className="relative z-10 max-w-2xl mx-auto">
              <div className="w-10 h-10 flex items-center justify-center mx-auto mb-6">
                <i className="ri-double-quotes-l text-4xl text-[#C9A0A0]"></i>
              </div>
              <p className="text-2xl md:text-3xl font-serif italic leading-relaxed text-[#2C2C2C] mb-6">
                医師免許はありません。<br />
                ただ、隣にいます。
              </p>
              <div className="w-10 h-10 flex items-center justify-center mx-auto mb-8">
                <i className="ri-double-quotes-r text-4xl text-[#C9A0A0]"></i>
              </div>
              <p className="text-sm text-[#888888]">ジェイゾロフト瞳</p>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
